import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import { useDojos } from '@/lib/queries';
import { Spinner } from '@/components/Layout';

const REGIONS: Record<string, string> = { north: 'North England', london: 'London region', south: 'South England', west_midlands: 'West Midlands', other: 'Other' };

export function Dojos() {
  const dojos = useDojos();
  const picked = useLocation().hash.slice(1); // "dojo-<id>" when linked from a member's dojo
  useEffect(() => { if (picked && dojos.data) document.getElementById(picked)?.scrollIntoView({ block: 'center' }); }, [picked, dojos.data]);
  if (dojos.isLoading) return <Spinner />;
  const byRegion = Object.entries(REGIONS).map(([k, label]) => ({ label, items: (dojos.data ?? []).filter(d => d.region === k) })).filter(g => g.items.length);
  return (
    <div className="space-y-8">
      <h1 className="text-2xl font-bold">Dojos</h1>
      {byRegion.map(g => (
        <section key={g.label}>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-ink-500">{g.label}</h2>
          <ul className="mt-3 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {g.items.map(d => (
              <li key={d.id} id={`dojo-${d.id}`} className={`card py-4 ${picked === `dojo-${d.id}` ? 'border-brand-600 ring-1 ring-brand-600' : ''}`}>
                <p className="font-semibold">{d.name}{d.is_honbu && <span className="pill ml-2 bg-brand-100 text-brand-800">Honbu</span>}</p>
                <p className="text-sm text-ink-500">{d.town}</p>
                {d.website && <a href={d.website} target="_blank" rel="noreferrer" className="mt-2 inline-flex items-center gap-1 text-sm link">Website <ExternalLink size={13} /></a>}
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
